import(/* webpackMode: "eager" */ "/home/runner/work/melb-coffee-club/melb-coffee-club/apps/web/components/OpenLineChart.tsx")